<template>
  <div
    class="card"
    :class="[`card--${card.kind}`, {
      'card--selected': selected,
      'card--lowest': lowest,
      'card--dimmed': dimmed,
    }]"
  >
    <img
      class="card__art"
      :src="`${base}card-art/${artFile}.jpg`"
      :alt="label"
      draggable="false"
    >
    <span v-if="lowest" class="card__tag">next to pass takes this</span>
  </div>
</template>

<script>
import { cardById, artFileOf, CARD_KINDS } from '@/engine/deck';

// One card, face up - a house or a cheque.
//
// The art is the whole card: houses wear their own number in the corner and
// cheques their amount, so there is no text overlay. `alt` carries the
// identity for anyone who can't see the picture.
export default {
  name: 'CardFace',
  props: {
    cardId: { type: String, required: true },
    // Buying phase: the cheapest house on the table, the one a passer takes.
    lowest: { type: Boolean, default: false },
    // Selling phase: the house I have picked to sell.
    selected: { type: Boolean, default: false },
    dimmed: { type: Boolean, default: false },
  },
  data() {
    return { base: process.env.BASE_URL || '/' };
  },
  computed: {
    card() {
      return cardById(this.cardId) || { id: this.cardId, kind: CARD_KINDS.PROPERTY, value: 0 };
    },
    artFile() {
      return artFileOf(this.card);
    },
    label() {
      return this.card.kind === CARD_KINDS.PROPERTY
        ? `House ${this.card.value}`
        : `A cheque for $${(this.card.value * 1000).toLocaleString('en-US')}`;
    },
  },
};
</script>
